import React, {Component} from "react";
import {Link} from "gatsby";

class Header extends Component {
  render() {
    return (
      <header className="header-z-c1 c-header fixed-top">
        <div className="header-z-c1-body c-header-body">
          <div className="header-z-c1-logo">HỎI ĐÁP TRỰC TUYẾN</div>
          <nav>
            <ul className="header-z-c1-nav">
              <li className="header-z-c1-nav-item">
                <Link
                  to="/"
                  key="/"
                  className="header-z-c1-nav-link"
                >
                  <i className="c-icon c-icon-new header-z-c1-nav-icon" />
                  Bài viết
                </Link>
              </li>
              <li className="header-z-c1-nav-item">
                <Link
                  to="/"
                  key="/"
                  className="header-z-c1-nav-link"
                >
                  <i className="c-icon c-icon-library header-z-c1-nav-icon" />
                  Hỏi đáp
                </Link>
              </li>
              <li className="header-z-c1-nav-item">
                <Link
                  to="/"
                  key="/"
                  className="header-z-c1-nav-link"
                >
                  <i className="c-icon c-icon-job header-z-c1-nav-icon" />
                  Việc làm
                </Link>
              </li>
              <li className="header-z-c1-nav-item">
                <Link
                  to="/"
                  key="/"
                  className="header-z-c1-nav-link"
                >
                  <i className="c-icon c-icon-tutorial header-z-c1-nav-icon" />
                  Buy me a coffee
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    );
  }
}

export default Header;
